import styled from '@emotion/styled';

import breakpoints from 'app/styles/constants/breakpoints';

const { widthMedium, widthSmall } = breakpoints;
const S = {};

S.Plans = styled.article`
  label: Plans;

  width: 100%;
  margin-top: 2rem;

  @media (${widthSmall}) {
    margin-top: 2.5rem;
  }

  @media (${widthMedium}) {
    margin-top: 3rem;
  }
`;

S.PlanItemsList = styled.ul`
  label: PlanItemsList;

  list-style-type: none;
  width: 100%;
  max-width: 63rem;
  display: grid;
  gap: 1rem 1.5rem;
  justify-content: center;
  grid-template-columns: minmax(0, 25rem);

  @media (${widthMedium}) {
    grid-auto-flow: column;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export default S;
